'use strict';


module.exports.encode = require('./encode');
module.exports.decode = require('./decode');
module.exports.format = require('./format');
module.exports.parse  = require('./parse');



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdurl/index.js
// module id = 343
// module chunks = 0